import { LicenciaEstado, LicenciaEstadoForm, LicenciaEstadoUpsert } from '@models/.';

export function transformToData(licenseState: LicenciaEstado | null): LicenciaEstado | null {
  if (!licenseState) return null;
  
  return {
    ...licenseState,
  };
}

export function transformToForm(licenseState?: LicenciaEstado): LicenciaEstadoForm | undefined {
  if (!licenseState) return;
  
  const {
    idLicenciaEstado: id,
    descripcion: description,
  } = licenseState
  
  return {
    id,
    description,
  };
}

export function transformToUpsert(licenseStateForm: LicenciaEstadoForm): LicenciaEstadoUpsert | undefined {
  if (!licenseStateForm) return;
  
  const {
    description: descripcion,
  } = licenseStateForm
  
  return {
    descripcion,
  };
}